// ============================================================
// HEALTH TIPS — generic, editable wellness content.
// Not medical advice; replace or expand as the hospital wishes.
// ============================================================

export const HEALTH_TIPS = [
  {
    icon: "droplets",
    title: "Stay Hydrated in Summer",
    excerpt:
      "Chhattisgarh summers can be harsh. Drink water regularly through the day, avoid prolonged midday sun, and watch for signs of heat exhaustion in children and elders.",
  },
  {
    icon: "shield",
    title: "Prevent Seasonal Infections",
    excerpt:
      "During monsoon, use clean drinking water, keep surroundings free of stagnant water, and consult a doctor early for persistent fever instead of self-medicating.",
  },
  {
    icon: "heart",
    title: "Routine Check-ups Matter",
    excerpt:
      "A simple annual health check-up can catch concerns like high blood pressure or high blood sugar early, when they are easiest to manage.",
  },
  {
    icon: "baby",
    title: "Children's Vaccinations",
    excerpt:
      "Keep your child's vaccination card up to date. If you are unsure about the schedule, bring the card to your next consultation and ask the doctor.",
  },
  {
    icon: "salad",
    title: "Balanced Everyday Meals",
    excerpt:
      "Include local seasonal vegetables, pulses and whole grains in daily meals. Small, consistent habits support long-term health more than short diets.",
  },
  {
    icon: "moon",
    title: "Sleep and Recovery",
    excerpt:
      "Adults generally benefit from 7–8 hours of regular sleep. Consistent sleep timings support immunity, mood and recovery from illness.",
  },
];
